/* eslint-disable no-undef */
import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import { CommonDialog } from '@bingads-webui-cc-react/dialogs';

const { AlertDialog } = CommonDialog;

const dialogContent = ({ i18n, accountNumbersList }) =>
  <>
    <p>
      {i18n.getString(_TL_('The reactivation action is successful but due to not having required account business location (ABL) information, the following account(s) can’t serve ads until ABL is completed. Please notify the customer to fill in corresponding fields on their account setting page.')) }
    </p>
    <p>
      {accountNumbersList}
    </p>
  </>;

export default class View extends Backbone.View {
  initialize({
    i18n,
    accountNumbers,
    onAction,
  }) {
    this.i18n = i18n;
    this.accountNumbersList = accountNumbers.join(', ');
    this.onAction = onAction;
  }

  hide() {
    ReactDOM.unmountComponentAtNode(this.el);
    this.remove();
  }

  render() {
    ReactDOM.render(React.createElement(
      AlertDialog,
      {
        name: 'bulk-reactivate-abl-missing',
        onAction: () => {
          this.hide();
          this.onAction();
        },
        title: this.i18n.getString(_TL_('Account business location (ABL) required')),
        content: dialogContent({ i18n: this.i18n, accountNumbersList: this.accountNumbersList }),
        alertButtonText: this.i18n.getString(_TL_('OK')),
      },
    ), this.el);
    return this;
  }
}
